// import config from '../config/config'
import axios from 'axios'
import Cookies from 'js-cookie'
import Vue from 'vue';
import config from '../config/config'

export default class Auth {
  static ACCESS_TOKE = '';

  static USER = {};
  static MASTER_STUDENTS = [];
  static MASTER = {};
  static ROOM = [];
  static EDU_PROGRAMS = [];
  static PERMISSIONS = [];
  static MENU_ITEMS = [];

  static AUTHORIZED = false;
  static CurrentEduProgram() {
    return this.EDU_PROGRAMS.find(a => a.id == localStorage.getItem("eduProgram"));
  }

  static GetDateTimeZone(date, returnDate = false) {
    return GETDATETIMEZONE(date, returnDate)
  }
  static async logIn(email, password) {
    try {
      const response = await axios.post('user-login', {
        email,
        password,
      })

      axios.defaults.headers.common.Authorization = `Bearer ${response.data.access_token}`
      Cookies.set('api_token', response.data.access_token)
      // this.connectLogIN(email);
      this.setData(response);
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  }
  static async impersonate(data) {
    let email = data.email;
    console.log(this.USER.email);
    Cookies.set('admin_email', this.USER.email);
    Cookies.remove('api_token');
    this.AUTHORIZED = false
    this.USER = {}
    try {
      const response = await axios.post('user-impersonate', {
        email
      })
      console.log(response.data.user.account_type);
      if (response.data.user.account_type == "student" && response.data.eduPrograms.length > 0) {
        localStorage.setItem("eduProgram", response.data.eduPrograms[0].id);
      }
      if (response.data.user.account_type == "teacher" && response.data.rooms.length > 0 && response.data.eduPrograms.length > 0) {
        let room_id = response.data.rooms[0].id;
        localStorage.setItem("room", room_id);
        // let program=response.data.eduPrograms.find((a) => a.id == response.data.rooms[0].edu_program_id);
        localStorage.setItem("eduProgram", response.data.rooms[0].edu_program_id);

      }
      Cookies.set('impersonate', true);
      axios.defaults.headers.common.Authorization = `Bearer ${response.data.access_token}`
      Cookies.set('api_token', response.data.access_token)
      // this.connectLogIN(email);
      this.setData(response);
      return true
    } catch (error) {
      console.error(error)
      return false
    }
  }
  static async finishImpersonate() {
    let email = Cookies.get('admin_email');
    Cookies.remove('api_token')
    this.AUTHORIZED = false
    this.USER = {}
    try {
      const response = await axios.post('user-impersonate', {
        email
      });
      Cookies.remove('admin_email');
      Cookies.remove('impersonate');
      axios.defaults.headers.common.Authorization = `Bearer ${response.data.access_token}`
      Cookies.set('api_token', response.data.access_token)
      this.setData(response);
      return true;
    } catch (error) {
      console.error(error)
      return false
    }
  }

  static connectLogIN() {
    const instance = axios.create({
      baseURL: config.serverConnectAPI,

    });
    let email = this.USER.email;
    const res = instance.post('/auth/login', {
      email
    }).then(res => {
      //, { domain: 'sub.example.com' }
      Cookies.set('CONNECT_TOKEN', res.data.token, {
        domain: 'sunnah.omg.com.eg'
      })
    })
  }
  static async loggedIn() {
    axios.defaults.baseURL = config.serverUrlApi

    if (this.AUTHORIZED) return true
    if (Cookies.get('api_token')) {
      axios.defaults.headers.common.Authorization = `Bearer ${Cookies.get('api_token')}`

      try {
        const response = await axios.get('user')
        console.log(response);
        this.setData(response);
        return true
      } catch (error) {
        console.error(error)
        this.AUTHORIZED = false
        this.USER = {}
        return false
      } // info
    }
    return false
  }
  static setData(response) {
    this.PERMISSIONS = [];


    this.MENU_ITEMS = [];
    this.AUTHORIZED = true
    this.USER = response.data.user
    this.ROOM = response.data.rooms
    this.PERMISSIONS = response.data.role[0].permissions.map(a => a.name)
    this.ROLE = response.data.role[0];
    if (response.data.master&&response.data.master.length > 0)
      this.MASTER = response.data.master[0];
    Vue.prototype.$role = Auth.ROLE.name;
    this.EDU_PROGRAMS = response.data.eduPrograms
    const master = localStorage.getItem("master");
    switch (this.ROLE.name) {
      case "super_admin":
        this.MENU_ITEMS = admin;
        break;
      case "contentadmin":
        this.MENU_ITEMS = contentadmin;
        break;
      case "multimediaadmin":
        this.MENU_ITEMS = multimediaadmin;
        break;
      case "QuranAdmin":
        this.MENU_ITEMS = QuranAdmin;
        break;
      case "student":
        const metaData = this.USER.metaData;
        if (metaData) {
          this.MENU_ITEMS = quranProgramStudent;

        }
        else if (master == 1) {
          this.MENU_ITEMS = studentMaster;
        } else {
          if (this.EDU_PROGRAMS.length == 0) this.MENU_ITEMS = newStudent;
          else this.MENU_ITEMS = student;
        }
        break;
      case "teacher":
        quranProgramTeacher
        this.MASTER_STUDENTS = response.data.master_students;
        const quran = localStorage.getItem('quran');

        if (quran == 1) {
          this.MENU_ITEMS = quranProgramTeacher;
        } else if (this.master == 1) {
          this.MENU_ITEMS = teacherMaster;
        }
        else {
          this.MENU_ITEMS = teacher;
        }
        break;
      case "distribution":
        this.MENU_ITEMS = distribution;
        break;
      case "graduate":
        this.MENU_ITEMS = graduate;
        break;
      case "vice_dean":
        this.MENU_ITEMS = vice_dean;
        break;
      case "colleage":
        this.MENU_ITEMS = colleage;
        break;
    }
    // this.MENU_ITEMS.forEach(element => {
    //   if (element.route)
    //     this.PERMISSIONS.push(element.route)
    //   if (element.children) {
    //     element.children.forEach(element => {
    //       if (!element.route.params)
    //         this.PERMISSIONS.push(element.route)
    //       else if (element.route.name)
    //         this.PERMISSIONS.push(element.route.name)


    //     })
    //   }
    //   if (element.childrenData) {
    //     element.childrenData.forEach(element => {
    //       this.PERMISSIONS.push(element)
    //     })
    //   }
    // })
    // // console.log(this.PERMISSIONS);
  }

  static logOut() {
    Cookies.remove('api_token')
    Cookies.remove('admin_email')
    Cookies.remove('impersonate')
    Cookies.remove('session_room_id')
    Cookies.remove('session_id')
    this.AUTHORIZED = false
    this.USER = {}
    window.location.href = '/dashboard'
    return false
  }
}